export default {
  "pwaDeviceList.thead.id": "ID",
  "pwaDeviceList.thead.bindSite": "BindSite",
  "pwaDeviceList.thead.channel": "Channel",
  "pwaDeviceList.thead.host": "Host",
  "pwaDeviceList.thead.fullUrl": "FullUrl",
  "pwaDeviceList.thead.endpoint": "Endpoint",
  "pwaDeviceList.thead.createTime": "CreateTime",
  "pwaDeviceList.thead.modifyTime": "ModifyTime",
  "pwaDeviceList.thead.action": "Action",
  "pwaDeviceList.title": "PWA Device List",
};